/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Cc_Mode_TitleInputs */



/**
* | output |
* | --- |
* | "Closed Captioning Mode" |
*
* @param {Styles_Cc_Mode_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_cc_mode_title = /** @type {((inputs?: Styles_Cc_Mode_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Cc_Mode_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mode sous-titrage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitelmodus")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modalità sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Режим субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modo de subtítulos cerrados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("隐藏式字幕模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クローズドキャプションモード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बंद कैप्शनिंग मोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modo de legenda oculta")
	return /** @type {LocalizedString} */ ("Closed Captioning Mode")
});